module.exports = __webpack_public_path__ + "static/media/circle_3.7b5b4199.svg";